<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>회원관리</h2>
                <div class="info_box">
                    <div>
                        탈퇴
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.removeCnt) }}명</span>
                    </div>
                    <div>
                        차단
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.blockCnt) }}명</span>
                    </div>
                    <div>
                        총 회원수
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.totalCnt) }}명</span>
                    </div>
                </div>
            </div>

            <div class="sch_condition_wrap">
                <div class="left">
                    <div class="select_tab_box _130">
                        <div
                            class="selected_tab"
                            :class="[state.isShowSearchType ? 'active' : '']"
                            @click="state.isShowSearchType = !state.isShowSearchType"
                        >
                            <span>{{ state.detailTxt }}</span>
                        </div>
                        <div class="tab_option" v-show="state.isShowSearchType" :class="[state.isShowSearchType ? 'active' : '']">
                            <button
                                v-for="item in search_type_list"
                                :key="item.key"
                                @click="
                                    state.searchType = item.key;
                                    state.detailTxt = item.value;
                                    state.isShowSearchType = false;
                                    if (item.key === 'all' || item.value === '전체') {
                                        state.page = 1;
                                        getList();
                                    }
                                "
                            >
                                {{ item.value }}
                            </button>
                        </div>
                    </div>

                    <div>
                        <template v-if="state.searchType == 'gender' || state.searchType == '3' || state.searchType == '성별'">
                            <select
                                class="gender_select"
                                v-model="state.searchText"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            >
                                <option value="">전체</option>
                                <option value="M">남자</option>
                                <option value="W">여자</option>
                                <option value="E">기타</option>
                            </select>
                        </template>

                        <template v-else>
                            <div class="search_wrap input_wrap" style="display: flex; align-items: center">
                                <input
                                    type="text"
                                    v-model="state.searchText"
                                    @keyup.enter="
                                        state.page = 1;
                                        getList();
                                    "
                                    placeholder="검색어를 입력하세요."
                                />
                                <button
                                    type="button"
                                    class="search_btn icon_wrap"
                                    @click="
                                        state.page = 1;
                                        getList();
                                    "
                                    style="margin-left: 4px"
                                >
                                    <img src="img/search_btn.png" alt="검색" />
                                </button>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="right">
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                    <button type="button"><img src="img/excel_icon.png" @click="downloadFile" alt="엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 60px" />
                        <col style="width: 100px" />
                        <col style="width: 150px" />
                        <col style="width: 40px" />
                        <col style="width: 130px" />
                        <col style="width: 130px" />
                        <col style="width: 130px" />
                        <col style="width: 80px" />
                        <col style="width: 60px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2" rowspan="2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th rowspan="2">번호</th>
                            <th rowspan="2">이름</th>
                            <th rowspan="2">아이디</th>
                            <th rowspan="2">성별</th>
                            <th rowspan="2">전화번호</th>

                            <th rowspan="2">가입일</th>
                            <th rowspan="2">최종접속</th>
                            <th rowspan="2">상태</th>
                            <th rowspan="2">관리</th>
                        </tr>
                    </thead>
                    <tbody style="max-height: 600px; overflow-y: auto">
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                    </label>
                                </td>
                                <td class="cnt">{{ CommonUtils.numberFormat((state.page - 1) * state.size + (idx + 1)) }}</td>
                                <td>{{ item.memberVO.name }}</td>
                                <td>{{ item.memberVO.id }}</td>
                                <td class="cnt p_5">{{ getGenderText(item.gender) }}</td>
                                <td class="cnt">{{ CommonUtils.convertPhoneNumReal(item.phone) }}</td>

                                <td class="cnt">
                                    {{ CommonUtils.dateFormat(new Date(item.memberVO.createDate), ".", true) }}
                                </td>
                                <td class="small cnt">
                                    {{ item.memberVO.loginDate ? CommonUtils.dateFormat(new Date(item.memberVO.loginDate), ".", true) : "" }}
                                </td>

                                <td class="cnt p_5">{{ getStateText(item.memberVO.state) }}</td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="modifyModal(item.memberVO.idx)">수정</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="14">
                                <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                :data="state.data"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <MemberManageModal
        v-if="state.isMemberShowModal"
        :data="state.data"
        :userInfo="state.userInfo"
        @modifyForMember="modifyForMember"
        @close="state.isMemberShowModal = false"
    ></MemberManageModal>

    <MemberPerformanceModal1
        v-if="state.isShowModalForPerformance && state.performanceTab === 1"
        :idx="state.performanceIdx"
        :userName="state.userName"
        :tab="state.performanceTab"
        @changeTab="changeTab"
        @close="state.isShowModalForPerformance = false"
    ></MemberPerformanceModal1>
    <MemberPerformanceModal2
        v-if="state.isShowModalForPerformance && state.performanceTab === 2"
        :idx="state.performanceIdx"
        :userName="state.userName"
        :tab="state.performanceTab"
        @changeTab="changeTab"
        @close="state.isShowModalForPerformance = false"
    ></MemberPerformanceModal2>
    <MemberPerformanceModal3
        v-if="state.isShowModalForPerformance && state.performanceTab === 3"
        :idx="state.performanceIdx"
        :userName="state.userName"
        :tab="state.performanceTab"
        @changeTab="changeTab"
        @close="state.isShowModalForPerformance = false"
    ></MemberPerformanceModal3>
    <MemberPerformanceModal4
        v-if="state.isShowModalForPerformance && state.performanceTab === 4"
        :idx="state.performanceIdx"
        :userName="state.userName"
        :tab="state.performanceTab"
        @changeTab="changeTab"
        @close="state.isShowModalForPerformance = false"
    ></MemberPerformanceModal4>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        MemberManageModal,
        MemberPerformanceModal1,
        MemberPerformanceModal2,
        MemberPerformanceModal3,
        MemberPerformanceModal4,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            Header,
            Left,
            ModalDefault,

            PageBtn,
            MemberManageModal,
            MemberPerformanceModal1: MemberPerformanceModal1,
            MemberPerformanceModal2: MemberPerformanceModal2,
            MemberPerformanceModal3: MemberPerformanceModal3,
            MemberPerformanceModal4: MemberPerformanceModal4,
        },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const email_domain_list = ["naver.com", "gmail.com", "daum.net"];
            const state = reactive({
                list: [] as Array<any>,
                checkedList: [] as Array<number>,
                checkAll: false as boolean,

                data: {},
                userInfo: {},

                removeCnt: 0 as number,
                blockCnt: 0 as number,
                totalCnt: 0 as number,

                isShowSearchType: false,
                detailType: null as number | null,
                detailTxt: "전체" as string,
                searchType: "" as string,
                searchText: "" as string,

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isMemberShowModal: false as boolean,

                item: {} as any,

                isShowModalForPerformance: false as boolean,
                performanceTab: -1 as number,
                performanceIdx: 0 as number,
                userName: "" as string,
                grade: 0 as number,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
                memberCnt();
            });

            onBeforeUnmount(() => {});

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );
            watch(
                () => state.searchType,
                () => {
                    state.searchText = "";
                },
            );

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const openModal = (tab: number, isResult: boolean) => {
                state.modalTab = tab;
                state.isShowModal = true;
                state.modalIsResult = isResult;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqUserForList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    grade: state.grade,
                };

                const res = await apiService.member.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const memberCnt = async () => {
                const res = await apiService.member.memberCnt();
                if (res.returnCode === 0) {
                    state.removeCnt = res.removeCnt;
                    state.blockCnt = res.blockCnt;
                    state.totalCnt = res.totalCnt;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqUserForExcel = {
                        searchType: state.searchType,
                        searchText: state.searchText,
                        idxList: state.checkedList.join(","),
                    };

                    let res = await apiService.member.exportExcel(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const param: types.ReqIdxList = {
                        idxList: state.checkedList.join(","),
                    };
                    const res = await apiService.member.remove(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const modifyModal = async (idx: number) => {
                state.isMemberShowModal = true;

                if (idx != null && idx > 0 && idx != undefined) {
                    const res = await apiService.member.detail(idx);
                    state.data = res.data;
                    state.userInfo = res.data.memberVO;
                }
            };

            const modifyForMember = async (idx: number, prop: types.ReqUserForModifyForAdmin) => {
                if (prop.pw && !prop.pwReCheck) {
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 올바르지 않습니다.";
                    state.isShowModal = true;
                } else if (!prop.zipCode || !prop.address) {
                    state.modalTitle = "알림";
                    state.modalContent = "주소를 입력해주세요";
                    state.isShowModal = true;
                } else if (!prop.nickName) {
                    state.modalTitle = "알림";
                    state.modalContent = "닉네임을 입력해주세요";
                    state.isShowModal = true;
                } else {
                    const res = await apiService.member.modify(idx, prop);
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "수정이 완료되었습니다.";
                        state.isShowModal = true;
                        state.isMemberShowModal = false;

                        getList();
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "문제 발생";
                        state.isShowModal = true;
                    }
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const search_type_list = [
                { id: "all", key: "all", value: "전체" },
                { id: "1", key: "name", value: "이름" },
                { id: "2", key: "id", value: "아이디" },
                { id: "3", key: "gender", value: "성별" },
                { id: "4", key: "phone", value: "전화번호" },
            ];

            const getStateText = (param: number) => {
                switch (param) {
                    case 1:
                        return "정상";
                    case 2:
                        return "탈퇴";
                    case 3:
                        return "차단";
                    default:
                        return "대기";
                }
            };

            const getGradeText = (param: number) => {
                switch (param) {
                    case 1:
                        return "일반";
                    case 2:
                        return "활동 선정자";

                    default:
                        return "일반";
                }
            };

            const getGenderText = (param: string) => {
                switch (param) {
                    case "M":
                        return "남자";
                    case "F":
                        return "여자";
                    default:
                        return "기타";
                }
            };

            const showArea = (idx: number, name: string) => {
                state.performanceIdx = idx;
                state.userName = name;
                changeTab(1);
            };
            const showAd = (idx: number, name: string) => {
                state.performanceIdx = idx;
                state.userName = name;
                changeTab(2);
            };
            const showActivity = (idx: number, name: string) => {
                state.performanceIdx = idx;
                state.userName = name;
                changeTab(3);
            };
            const showEvent = (idx: number, name: string) => {
                state.performanceIdx = idx;
                state.userName = name;
                changeTab(4);
            };
            const changeTab = (tab: number) => {
                state.performanceTab = tab;
                state.isShowModalForPerformance = true;
            };

            return {
                state,
                user,
                email_domain_list,
                router,
                closeModal,
                openModal,
                callBackModal,
                imgError,
                types,
                global,
                popup,
                handlePageChange,
                CommonUtils,
                search_type_list,
                getGradeText,
                getStateText,
                getGenderText,
                getList,

                toggleAll,
                downloadFile,
                isDelete,

                showArea,
                showAd,
                showActivity,
                showEvent,
                changeTab,
                modifyModal,

                modifyForMember,
            };
        },
    };
</script>
<style scoped>
    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }

    .checkbox_wrap2 em {
        display: none;
    }

    .gender_select {
        width: 90px;
        border: 1px solid var(--border_col);
        border-radius: 5px;
        height: 35px;
        display: flex;
        align-items: center;
        height: 35px;

        padding: 0 10px;
        font-size: 15px;
        outline: none;
    }

    .gender_select option {
        color: #333;
        background-color: #fff;
        font-size: 14px;
        font-weight: 500;
        /* display: inline-block;
        vertical-align: middle;
        padding: 0 10px;
        border: 0;
        font-weight: 500;
        color: var(--font_color);
        cursor: pointer; */
    }

    .common_table thead tr {
        position: initial;
    }

    .blue_box._full .common_table {
        max-height: 100%;
    }

    .common_table.custom_scroll > table > thead {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: var(--th_color);
    }

    /* .tab_option.active {
        visibility: visible;
        height: auto;
        opacity: 1;
    } */
</style>

<style>
    .pop_up.flex_box {
        height: auto;
    }
</style>
